"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => {
    throw new Error('File system is not available');
};
//# sourceMappingURL=browser.js.map